module.exports = __webpack_public_path__ + "img/sandstone.6d3cb939.png";